import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafCollectionVarianceRouteWiseReport } from './Pages';

export const LeafCollectionVarianceRouteWiseReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LeafCollectionVarianceRouteWiseReport} />
    </Fragment>
)